import { useTranslation } from "react-i18next";
import CategoryDropdown from "@/components/feature/CategoryDropdown";
import { categories, categoryImages } from "@/mocks/categories";

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="w-full scroll-mt-24 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("cat.title")}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t("cat.subtitle")}</p>
        </div>

        <div className="mt-8 flex justify-center">
          <CategoryDropdown />
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.href}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/70 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-32 w-full overflow-hidden md:h-36">
                <img
                  src={categoryImages[c.id]}
                  alt={`${t(`cat.${c.id}`)} — USFans Spreadsheet`}
                  title={`${t(`cat.${c.id}`)} — USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between gap-2 px-3 py-3">
                <span className="whitespace-nowrap text-sm font-semibold text-foreground-800">
                  {t(`cat.${c.id}`)}
                </span>
                <span className="w-4 h-4 flex shrink-0 items-center justify-center">
                  <i className="ri-arrow-right-up-line text-foreground-400 transition-colors group-hover:text-primary-600"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}